<template>
  <section>
    <b-collapse
      :open="false"
      class="card"
      animation="slide"
      aria-id="examples">
      <template #trigger="props">
        <div
          class="card-header"
          role="button"
          aria-controls="examples">
          <p class="card-header-title">
            Category Lookup
          </p>
          <a class="card-header-icon">
            <b-icon :icon="props.open ? 'menu-down' : 'menu-up'">
            </b-icon>
          </a>
        </div>
      </template>
      <div class="card-content">
        <div class="content">
          <p>Enter a word or phrase to view its categories in the Ask Dmitri database.</p>
          <b-field grouped>
          <b-input v-model="query"/>
            <p class="control">
              <b-button
                class="button is-primary"
                v-on:click="doSearch"
                :disabled="!query || isLoading">
                Go
              </b-button>
            </p>
          </b-field>
        </div>
        <div v-if="errorMessage">
          {{errorMessage}}
        </div>
        <div v-if="results">
          <span
            v-for="result in results"
            class="compactResult"
            :key="result">
            {{ result }}
          </span>
        </div>
      </div>
    </b-collapse>
  </section>
</template>

<script>

import axios from 'axios';

const path = `${process.env.VUE_APP_API_URL}/categories`;

export default {
  props: {
    open: Boolean,
  },
  data() {
    return {
      query: '',
      errorMessage: '',
      isLoading: false,
      results: [],
    };
  },
  methods: {
    doSearch() {
      this.isLoading = true;
      this.errorMessage = '';
      this.results = [];
      axios.get(path, {
        params: {
          query: this.query,
        },
      })
        .then((res) => {
          this.results = res.data.results;
          this.isLoading = false;
          if (res.data.error) {
            this.errorMessage = res.data.error;
          }
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.error(error);
          this.isLoading = false;
        });
    },
  },
};
</script>

<style scoped>
.card {
  margin: 15px;
  margin-top: 20px;
}
.card-content {
  overflow: auto;
}
span.compactResult {
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 0px 3px;
  margin: 3px 3px;
  float: left;
}
</style>
